import Swiper from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { EffectCoverflow, Keyboard, Autoplay } from "swiper/modules";
export function initSliderFullWidthAutoplay(selector) {
    if (document.querySelector(selector)) {
        if (window.screen.width >= 1024) {
            var swiper = new Swiper(selector, {
                modules: [EffectCoverflow, Keyboard, Autoplay],
                slidesPerView: 6,
                spaceBetween: 10,
                centeredSlides: true,
                initialSlide: 0,
                autoHeight: false,
                loop: true,
                autoplay: {
                    delay: 4000,
                    pauseOnMouseEnter: true,
                },
                keyboard: {
                    enabled: true,
                    onlyInViewport: false,
                },
            });
        }
        else {
            var swiper = new Swiper(selector, {
                modules: [EffectCoverflow, Keyboard, Autoplay],
                slidesPerView: 1,
                spaceBetween: 10,
                centeredSlides: true,
                initialSlide: 0,
                autoHeight: false,
                loop: true,
                autoplay: true,
                keyboard: {
                    enabled: true,
                    onlyInViewport: false,
                },
            });
        }
    }
}
